import React from 'react';
import { useTranslation } from 'react-i18next';
import Icon from '@cx-web/components/primitives/icon';

import styles from '../../MobileBottomNav.module.css';

interface AllSportsButtonProps {
  allSportsOpen: boolean;
  isIT: boolean;
  setAllSportsOpen: (open: boolean) => void;
}

export const AllSportsButton = ({ allSportsOpen, isIT, setAllSportsOpen }: AllSportsButtonProps) => {
  const { t } = useTranslation(['label']);
  // TODO this is a workaround to change the icon color based on the repub for now, we need to change this when we change the API response to include the icon for All Sports
  const icon = isIT ? 'Soccer' : 'AmericanFootball';
  const fill = isIT ? 'white' : '';
  const height = isIT ? 16 : 20;
  const width = isIT ? 16 : 20;
  return (
    <li
      className={`${styles.menuItem} ${styles.allSportsButton} ${allSportsOpen ? styles.active : ''}`}
      id="all-sports-button"
      key={'allSports'}
      onClick={() => setAllSportsOpen(!allSportsOpen)}
    >
      <span className={styles.iconContainer}>
        <Icon fill={fill} height={height} icon={icon} width={width} />
      </span>
      {t('CX_ODDS')}
    </li>
  );
};
